import { mergeWith } from 'lodash-es';
import { createI18n } from 'vue-i18n';
/**
 * Collects messages from locale contexts
 *
 * @param contexts Webpack "require" context (require.context) array
 */
function collectMessages(...contexts) {
    const messages = {};
    contexts.forEach((context) => {
        context.keys().forEach((key) => {
            const matched = key.match(/([A-Za-z0-9-_]+)\./i);
            if (matched && matched.length > 1) {
                const locale = matched[1];
                messages[locale] = Object.assign({}, messages[locale], context(key));
            }
        });
    });
    return messages;
}
const SUPPORTED_LANGUAGES = [
    'az',
    'bg',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'it',
    'iw',
    'nl',
    'pl',
    'pt',
    'ru',
    'sw',
    'th',
    'uk',
    'vi',
];
export function createI18nInstance(app, language = 'en') {
    const vueComponentsMessages = SUPPORTED_LANGUAGES.reduce((map, current) => {
        map[current] = require(`@agritask/vue-components/src/js/vue/locales/${current}.json`);
        return map;
    }, {});
    const localMessages = collectMessages(require.context('@/vue/locales/', true, /\.json$/));
    const messages = mergeWith(vueComponentsMessages, localMessages);
    const vuei18n = createI18n({
        locale: language,
        fallbackLocale: 'en',
        messages,
        legacy: false,
    });
    app.use(vuei18n);
    return vuei18n;
}
